import { getCookie } from 'src/scripts/utils/cookies';
import { getActiveVariationIds } from 'src/scripts/utils/optimizely';
import { SORT_BY_KEY } from '../../product-listing-page/components/sorting-utils';
import { getSessionUtmParameters } from 'src/scripts/utils/marketing';

export const experimentId = '18802302798';
export const variationName = 'Regular Pagination';
export const ITEMS_PER_PAGE = 25;
export const MAX_FILTER_ITEMS_SHOWN = 12;

export const NON_FILTER_QUERY_PARAMS = [
  'q',
  '_ga',
  '__a',
  'addToWishlist',
  'addToWishlistSource',
  'auth_success',
  'is_modal',
  'auth_event',
  'origq',
  SORT_BY_KEY,
  // Branch.io deeplink parameters - should not be treated as search filters
  '_branch_match_id',
  '_branch_referrer',
  'utm_source',
  'utm_medium',
  'utm_campaign',
  'utm_content',
  'utm_term',
];

export const getBrowseApiHeaders = () => {
  const currentUrl = window.location.href;
  const refUrl = document.referrer;
  const BR_DEVICE_ID = getCookie('_br_uid_2');
  const sessionUtmParams = getSessionUtmParameters();

  const staticHeaders = {
    Accept: 'application/json',
    'Content-Type': 'application/json',
    'BR-CurrentUrl': currentUrl || 'NO_CURRENT_URL',
    'BR-RefUrl': refUrl || 'NO_REFERRER_URL',
    'BR-DeviceId': BR_DEVICE_ID || 'NO_DEVICE_ID',
  } as const;

  const headers: typeof staticHeaders & Record<string, string> = { ...staticHeaders };

  if (sessionUtmParams.utm_campaign && sessionUtmParams.utm_medium) {
    headers['BR-Session-Utm-Campaign'] = sessionUtmParams.utm_campaign;
    headers['BR-Session-Utm-Medium'] = sessionUtmParams.utm_medium;
  }

  const brVariants = getActiveVariationIds();
  if (brVariants?.length > 0) {
    headers['BR-Variation-Ids'] = brVariants.join(',');
  }

  return headers;
};
